import { Box, Typography, Grid, useTheme } from '@mui/material';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';

interface NetworkSettingsProps {
  data: {
    portQuantity?: number;
    finalPortQuantity?: number;
  };
}

export function NetworkSettings({ data }: NetworkSettingsProps) {
  const theme = useTheme();

  return (
    <Box sx={{ mt: 4 }}>
      <Typography fontWeight={700} fontSize={18} color={theme.palette.text.primary} mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <SettingsEthernetIcon sx={{ color: theme.palette.primary.main, fontSize: 22 }} /> Configurações de Rede
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Box sx={{
            p: 2.5,
            border: '2px solid #A7F3D0',
            borderRadius: 3,
            backgroundColor: '#E6F9ED',
            textAlign: 'center',
            transition: 'transform 0.2s ease-in-out',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
              <SettingsEthernetIcon sx={{ color: '#22C55E', fontSize: 20 }} />
              <Typography fontWeight={600} color={'#22C55E'} fontSize={14}>
                Quantidade de Portas
              </Typography>
            </Box>
            <Typography fontWeight={800} fontSize={24} color={'#22C55E'}>
              {data.portQuantity}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box sx={{
            p: 2.5,
            border: '2px solid #BAE6FD',
            borderRadius: 3,
            backgroundColor: '#E6F4FF',
            textAlign: 'center',
            transition: 'transform 0.2s ease-in-out',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
              <SettingsEthernetIcon sx={{ color: '#3B82F6', fontSize: 20 }} />
              <Typography fontWeight={600} color={'#3B82F6'} fontSize={14}>
                Portas Finais
              </Typography>
            </Box>
            <Typography fontWeight={800} fontSize={24} color={'#3B82F6'}>
              {data.finalPortQuantity}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
} 